export default __webpack_public_path__ + "static/media/Amended_Category_H_Underlay.62e1b53c.jpeg";